import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Phone } from 'lucide-react';
import { formatCurrency } from '../../utils/currency.utils';

interface HeaderProps {
    cartItemsCount: number;
    cartTotal: number;
}

const Header: React.FC<HeaderProps> = ({ cartItemsCount, cartTotal }) => {
    const formattedTotal = formatCurrency(cartTotal);

    return (
        <header className="hidden lg:block bg-white border-b border-gray-200 py-3">
            <div className="container mx-auto px-4 flex justify-between items-center">
                <div className="flex-1">
                    <div className="flex items-center">
                        <Phone className="mr-2 h-4 w-4 text-primary-600" />
                        <a
                            href="tel:+359877769575"
                            className="text-sm font-semibold text-primary-600 hover:text-primary-700 hover:underline transition-colors"
                        >
                            +359 877 769 575
                        </a>
                    </div>
                </div>

                <div className="flex-1 flex justify-center relative z-10">
                    <Link to="/" className="flex justify-center">
                        <img src={require('../../email_logo.jpg')} alt="PC Center" className="h-20 mx-auto"/>
                    </Link>
                </div>

                <div className="flex-1 flex justify-end">
                    <Link to="/cart" className="flex items-center text-sm group">
                        <ShoppingCart className="mr-2 h-5 w-5 text-gray-600 group-hover:text-primary-500 transition-colors" />
                        <span>
                            Количка ({cartItemsCount}) - {formattedTotal}
                        </span>
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Header;